<template>
  <div>
    <!-- 轮播图 -->
    <!-- <div id="swiper" class="container-fuild">
      <div class="swiper-container banner-swiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in swiperList"
            :key="index"
          >
            <img class="swiper-lazy" :data-src="item.image" alt="轮播图" />
            <div class="swiper-lazy-preloader"></div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div> -->
    <swiper
      id="swiper"
      class="swiper container-fuild"
      :options="swiperOption"
    >
      <swiper-slide v-for="(item, index) in swiperList" :key="index">
        <img class="swiper-lazy" :src="item.image" alt="轮播图" />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
// import Swiper from "swiper";
import Bus from "@/untils/bus.js";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { carousel} from "@/api/api";
import "swiper/css/swiper.css";
export default {
  name: "swiper-example-loop",
  title: "Loop mode / Infinite loop",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        centeredSlides: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperList: [
        {
          image:
            "https://fenghuangzhanhui-1303119254.file.myqcloud.com/upload/20210816090119/337673814a5a40698a507bccf905ec04.jpg",
        },
      ],
    };
  },
  mounted() {
    console.log('zzzzzzz刷新');
    this.getCarousel()
    // Bus.$on("swiperList", (swiperList) => {
    //   console.log("接收到了11", swiperList);
    //   this.swiperList = swiperList;
    // });
    //   /* banner-swiper */
    //   new Swiper(".banner-swiper", {
    //     loop: true, // 循环模式选项
    //     effect: "fade",
    //     //自动播放
    //     autoplay: {
    //       delay: 3000,
    //       stopOnLastSlide: false,
    //       disableOnInteraction: false,
    //     },
    //     // 如果需要分页器
    //     pagination: {
    //       el: ".swiper-pagination",
    //       clickable: true,
    //     },
    //     // 如果需要前进后退按钮
    //     navigation: {
    //       nextEl: ".swiper-button-next",
    //       prevEl: ".swiper-button-prev",
    //     },
    //     // 延迟加载
    //     lazy: {
    //       loadPrevNext: true,
    //     },
    //     observer: true, //修改swiper自己或子元素时，自动初始化swiper
    //     observeParents: true, //修改swiper的父元素时，自动初始化swiper
    //   });
    //   /* customer-swiper */
    //   new Swiper(".customer-swiper", {
    //     loop: true, // 循环模式选项
    //     slidesPerView: 3,
    //     //自动播放
    //     autoplay: {
    //       delay: 3000,
    //       stopOnLastSlide: false,
    //       disableOnInteraction: false,
    //     },
    //     // 如果需要前进后退按钮
    //     navigation: {
    //       nextEl: ".swiper-button-next",
    //       prevEl: ".swiper-button-prev",
    //     },
    //     observer: true, //修改swiper自己或子元素时，自动初始化swiper
    //     observeParents: true, //修改swiper的父元素时，自动初始化swiper
    //   });
  },
  methods: {
     async getCarousel() {
      const res = await carousel();
      console.log("轮播图", res);
      if (res.code === 200) {
        // Bus.$emit("swiperList", res.data);
        this.swiperList = res.data;
      }
    },
  },
};
</script>

<style scoped>
/* 轮播图 */
#swiper {
  max-height: 350px;
}
#swiper img {
  width: 100%;
  height: 100%;
}
/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  #swiper {
    height: 200px;
  }
}
/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  #swiper {
    height: 400px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/RotationChart.vue